import { StatusLabelEnum } from 'src/app/components/status-label/status-label.component';
import { ViolationStatus } from 'src/app/models/api/violations.model';

export class ViolationRowHelpers {
  public static getStatusLabel(violationStatus: ViolationStatus): StatusLabelEnum {
    switch (violationStatus) {
      case ViolationStatus.exempted:
        return StatusLabelEnum.exempted;
      case ViolationStatus.open:
        return StatusLabelEnum.open;
      case ViolationStatus.resolved:
        return StatusLabelEnum.resolved;
    }
  }
}
